<template>
  <div id="app">
    <!-- <myHead class="myhead"></myHead> -->
    <router-view/>
  </div>
</template>

<style lang="scss">
.myhead{
  position:fixed;
  top:0px;
  display: none;
  width:5.5rem;
  z-index: 999;
  background-color: #fff;
}
</style>
<script>
import myHead from '@/components/head'
export default {
  components:{
    myHead
  }
}
</script>
